export default __webpack_public_path__ + "static/media/002-tongue-depressor-wood.2d4bff08.svg";